import * as React from 'react'
import { useState } from 'react'
import { styled } from '@design/pt-ui'
import { Img } from 'react-image'
import GifPlayer from '../GifPlayer'

import defaultThumbnail from '../../assets/images/no-IMG.png'
import { Asset } from '../../interfaces/entities/assets'
import { PlayCircleFilledTwoTone as PlayCircleFilledTwoToneIcon } from '@mui/icons-material'

const VideoContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#000',
  position: 'relative',
})

const PlayIcon = styled(PlayCircleFilledTwoToneIcon)({
  position: 'absolute',
  width: 60,
  height: 60,
  fill: '#fff',
  cursor: 'pointer',
  pointerEvents: 'none',
})

interface VideoProps {
  onClick?: () => any
  thumbnail: string
  height: number
  width: number
}

export const VideoComponent = (props: VideoProps) => {
  const { thumbnail, width, height } = props

  return (
    <VideoContainer>
      <PlayIcon />
      <div style={{ opacity: 0.6 }}>
        <ImageComponent
          onClick={props.onClick}
          src={thumbnail}
          width={width}
          height={height}
        />
      </div>
    </VideoContainer>
  )
}

type ImageProps = {
  onClick?: () => any
  src: string
  height: number
  width: number
}

export const ImageComponent = (props: ImageProps) => {
  const { src, width, height } = props
  return (
    <div
      style={{
        cursor: props.onClick ? 'pointer' : undefined,
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <img
        // @ts-ignore
        loading="lazy"
        onClick={props.onClick}
        src={src}
        style={{
          display: 'block',
          maxWidth: width,
          maxHeight: height,
          width: 'auto',
          height: 'auto',
        }}
        alt=""
        onError={(e: any) => (e.target.src = defaultThumbnail)}
      />
    </div>
  )
}

type GifProps = {
  onClick?: () => any
  src: string
  thumbnail: string
  height: number
  width: number
}

export const GifComponent = (props: GifProps) => {
  const { src, thumbnail, width, height } = props
  const imgStyle = {
    display: 'block',
    maxWidth: width,
    maxHeight: height,

    width: 'auto',
    height: 'auto',
  }

  if (props.onClick) {
    return (
      <div
        style={{
          cursor: 'pointer',
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Img onClick={props.onClick} style={[src, thumbnail]} sx={imgStyle} />
      </div>
    )
  } else {
    return (
      <GifPlayer
        autoplay={false}
        style={imgStyle}
        gif={src}
        still={thumbnail}
      />
    )
  }
}

interface CarouselProps {
  onAssetClick?: () => any
  assets: Asset[]
  height: number
  width: number
}

const renderAsset = (
  asset: Asset,
  width: number,
  height: number,
  onClick?: () => any,
) => {
  if (asset.type === 'video') {
    return (
      <VideoComponent
        thumbnail={asset.thumbnail}
        height={height}
        width={width}
        onClick={onClick}
      />
    )
  }

  if (asset.type === 'image') {
    return (
      <ImageComponent
        onClick={onClick}
        src={asset.source}
        height={height}
        width={width}
      />
    )
  }

  return null
}

export const Carousel = (props: CarouselProps) => {
  const { assets, width, height } = props
  const [current, setCurrent] = useState(0)

  const buttonStyle = {
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    opacity: 1,
    cursor: 'pointer',
  }

  const nextSlide = () => {
    if (current === assets.length - 1) {
      setCurrent(0)
    } else {
      setCurrent((c) => c + 1)
    }
  }

  const previousSlide = () => {
    if (current === 0) {
      setCurrent(assets.length - 1)
    } else {
      setCurrent((c) => c - 1)
    }
  }

  return (
    <div
      style={{
        width,
        height,
        position: 'relative',
      }}>
      {assets.map((asset, i) => {
        return (
          <div
            key={i}
            style={{
              position: 'absolute',
              float: 'left',
              WebkitTransition: 'opacity 1s ease-in-out',
              MozTransition: 'opacity 1s ease-in-out',
              OTransition: 'opacity 1s ease-in-out',
              transition: 'opacity 1s ease-in-out',
              opacity: i === current ? 1 : 0,
            }}>
            {renderAsset(asset, width, height, props.onAssetClick)}
          </div>
        )
      })}
      <div
        className="slider-left-button"
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
        }}>
        <button
          style={buttonStyle}
          onClick={previousSlide}
          aria-label="previous">
          {'<'}
        </button>
      </div>
      <div
        className="slider-right-button"
        style={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
        }}>
        <button style={buttonStyle} onClick={nextSlide} aria-label="next">
          {'>'}
        </button>
      </div>
    </div>
  )
}
